
import React from "react";
import { Footer } from "./Footer";
import { PromotionSection } from "./PromotionSection";
import { Header } from "./layout/Header";
import { PageTitle } from "./layout/PageTitle";
import { useIsMobile } from "@/hooks/use-mobile";

interface PageLayoutProps {
  children: React.ReactNode;
  title: React.ReactNode;
  description: string;
  breadcrumbs?: { label: string; path: string }[];
  reliabilityLevel?: 1 | 2 | 3 | 4 | 5;
}

export const PageLayout = ({
  children,
  title,
  description,
  breadcrumbs = [],
  reliabilityLevel,
}: PageLayoutProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="flex-1 flex flex-col min-h-screen w-full max-w-[100vw] overflow-x-hidden">
      <Header />
      
      <div className="flex-1 w-full mt-[72px] overflow-x-hidden">
        <div className="w-full max-w-none mx-auto">
          <PageTitle 
            title={title} 
            description={description} 
            reliabilityLevel={reliabilityLevel} 
          />
          {children}
        </div>
      </div>

      <PromotionSection />
      
      <Footer />
    </div>
  );
};
